export default __webpack_public_path__ + "static/media/mushroom.8348d850.png";